export enum AppRoutes {
  AccountList = '/crm/account/list',
  AccountDetail = '/crm/account-detail/:id',
  ApplicationDetail = '/app/application-detail/:id',
  ApplicationList = '/app/application/list',
  BaseRequirementDetail = '/ccfg/base-requirement-detail/:id',
  BaseRequirementList = '/ccfg/base-requirement/list',
  CountrySetupDetail = '/ccfg/country-setup-detail/:id',
  CountrySetupList = '/ccfg/country-setup/list',
  CountryTemplateList = '/ccfg/country-template/list',
  CountryTemplateDetail = '/ccfg/country-template-detail/:id',
  OrganisationList = '/crm/organisation/list',
  OrganisationDetail = '/crm/organisation-detail/:id',
  PartnerList = '/crm/partner/list',
  PartnerDetail = '/crm/partner-detail/:id',
  RequirementDetail = '/ccfg/requirement-detail/:id',
  UserDetail = '/crm/user/:id',
}
